import { motion } from "framer-motion";
import { TProductDetail } from "../../types";
import { formatCurrency } from "../../utils/format-number";
import { MdGridView } from "react-icons/md";
import { Link } from "react-router-dom";

export const SingleProduct = ({
  item,
  col,
}: {
  item: TProductDetail;
  col?: boolean;
}) => {
  const { name, price, image, ingredients, code } = item;

  return (
    <Link to={`/products/${code}`}>
      <motion.div
        whileTap={{ rotate: [0, -1, 1, -1, 0] }}
        className={`${
          !col ? "w-[275px] min-w-[275px]" : "w-[320px] min-w-[320px]"
        } md:w-[300px] md:min-w-[300px] ${
          col ? "my-12" : "my-2 md:my-5"
        } h-auto bg-cardOverlay rounded-lg p-2 px-3 backdrop-blur-lg hover:drop-shadow-sm cursor-pointer`}
      >
        <div className="flex items-center justify-between w-full">
          <motion.img
            whileHover={{ scale: 1.2 }}
            whileTap={{ scale: 1.1 }}
            className="object-contain w-40 h-40 -mt-8 cursor-pointer md:w-48 md:h-40"
            alt={ingredients}
            src={image}
          />
          <motion.div
            whileTap={{ scale: 1.1 }}
            whileHover={{ scale: 1.2 }}
            className="flex items-center justify-center w-8 h-8 bg-red-600 rounded-full cursor-pointer md:w-10 md:h-10"
            onClick={() => {}}
            title="Add to cart"
          >
            <MdGridView className="text-white md:text-xl" />
          </motion.div>
        </div>
        <div className="flex flex-col items-end justify-end w-full">
          <p className="text-lg text-textColor font-semi-bold line-clamp-1">
            {name}
          </p>
          <p className="mt-1 mb-2 text-sm text-gray-500 line-clamp-3">
            {ingredients}
          </p>
          <div className="flex items-center justify-between gap-8">
            <p className="text-lg font-semibold text-red-600 ">
              {formatCurrency(price)}
            </p>
          </div>
        </div>
      </motion.div>
    </Link>
  );
};
